// 用户支付行为打点
// http://api.umucdn.cn/project/216/interface/api/3068
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { isAndroid, isIos, isInMobile } from '@umu/umu-ua';

export enum PAGE_TYPE {
    COMMODITY_UPGRADE_PAGE = 'page_upgrade', // 升级页面
    COMMODITY_ORDER_PAGE = 'page_order', // 订单页面
}

// 访问-view, 点击免费试用click_free, 点击专用版click_profession,点击商业版click_business,点击联系销售click_contract, 点击订单购买 click_order
export enum ACTION_TYPE {
    VIEW = 1,
    CLICK_FREE = 2,
    CLICK_PROFESSION = 3,
    CLICK_BUSINESS = 4,
    CLICK_CONTRACT = 5,
    CLICK_ORDER = 2,
}

export enum DEVICE_FROM {
    PC = 1,
    Mobile = 2,
    Android = 3,
    IOS = 4,
}
// 设备映射关系
export const DEVICE_FROM_MAP = {
    twww: 1,
    mobile: 2,
    android: 3,
    ios: 4,
};

export interface IInput {
    page_type: PAGE_TYPE;
    action_type: ACTION_TYPE;
    device_from?: DEVICE_FROM;
}

export interface IOutput {
    status: number;
}

function getDevice() {
    if (isAndroid) {
        return DEVICE_FROM.Android;
    }
    if (isIos) {
        return DEVICE_FROM.IOS;
    }
    if (isInMobile()) {
        return DEVICE_FROM.Mobile;
    }
    return DEVICE_FROM.PC;
}

// tslint:disable-next-line:max-line-length
export const trackPaymentEvent = (data: IInput): Promise<IResponse<IOutput>> => {
    if (!data.device_from) {
        data.device_from = getDevice();
    }
    return fetchData(Api.USER_PAYMENT_EVENT, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
